// import React, { useState } from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout4Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout4: React.FC<FooterNavLayout4Props> = ({ colors }) => {
//   const items = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home' },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' },
//   ];

//   const [activeIndex, setActiveIndex] = useState<number>(2);

//   return (
//     <div
//       className="rounded-xl px-2 py-2 shadow-[0_16px_36px_rgba(0,0,0,0.2)]"
//       style={{ backgroundColor: colors.background }}
//     >
//       <div className="grid grid-cols-5 gap-0">
//         {items.map((item, index) => {
//           const Icon = item.icon;
//           const isActive = index === activeIndex;
//           return (
//             <button
//               key={item.label}
//               type="button"
//               onClick={() => setActiveIndex(index)}
//               className="relative flex flex-col items-center justify-center py-0 border-r last:border-r-0"
//               style={{ borderColor: 'rgba(255,255,255,0.2)', background: 'transparent' }}
//             >
//               {/* Active tab should cover full height */}
//               {isActive && (
//                 <div
//                   className="absolute inset-0 rounded-t-2xl shadow-[0_14px_30px_rgba(0,0,0,0.35)]"
//                   style={{ backgroundColor: colors.activeBackground }}
//                 />
//               )}
//               <div className="relative z-10 flex flex-col items-center py-2">
//                 <Icon className="mb-1" style={{ color: isActive ? colors.activeText : '#ffffff', width: 20, height: 20 }} />
//                 <span className="text-xs font-medium" style={{ color: isActive ? colors.activeText : '#ffffff' }}>
//                   {item.label}
//                 </span>
//               </div>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default FooterNavLayout4;



// import React, { useState } from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout4Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout4: React.FC<FooterNavLayout4Props> = ({ colors }) => {
//   const items = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home' },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' },
//   ];

//   const [activeIndex, setActiveIndex] = useState<number>(0);

//   return (
//     <div
//       className="rounded-2xl px-1 py-3 shadow-[0_16px_36px_rgba(0,0,0,0.2)] overflow-visible"
//       style={{ backgroundColor: colors.background }}
//     >
//       <div className="grid grid-cols-5 gap-0 items-end">
//         {items.map((item, index) => {
//           const Icon = item.icon;
//           const isActive = index === activeIndex;
//           return (
//             <button
//               key={item.label}
//               type="button"
//               onClick={() => setActiveIndex(index)}
//               className={`relative flex flex-col items-center justify-center transition-all duration-200 ${
//                 isActive ? '-translate-y-4' : ''
//               }`}
//               style={{ background: 'transparent' }}
//             >
//               {/* Active tab background */}
//               <div
//                 className={`rounded-2xl transition-all duration-200 ${
//                   isActive ? 'shadow-[0_8px_24px_rgba(0,0,0,0.25)]' : ''
//                 }`}
//                 style={{
//                   backgroundColor: isActive ? colors.activeBackground : 'transparent',
//                   padding: isActive ? '20px 16px' : '12px 16px',
//                 }}
//               >
//                 <Icon
//                   className="mb-1"
//                   style={{
//                     color: isActive ? colors.activeText : '#ffffff',
//                     width: 24,
//                     height: 24,
//                   }}
//                 />
//                 <span
//                   className="text-xs font-medium whitespace-nowrap"
//                   style={{ color: isActive ? colors.activeText : '#ffffff' }}
//                 >
//                   {item.label}
//                 </span>
//               </div>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default FooterNavLayout4;






//import React, { useState } from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout4Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout4: React.FC<FooterNavLayout4Props> = ({ colors }) => {
//   const items = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home' },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' },
//   ];

//   const [activeIndex, setActiveIndex] = useState<number>(2);

//   return (
//     <div
//       className="rounded-2xl px-1 py-2 shadow-[0_16px_36px_rgba(0,0,0,0.2)] overflow-visible"
//       style={{ backgroundColor: colors.background }}
//     >
//       <div className="grid grid-cols-5 gap-0 items-end">
//         {items.map((item, index) => {
//           const Icon = item.icon;
//           const isActive = index === activeIndex;
//           return (
//             <button
//               key={item.label}
//               type="button"
//               onClick={() => setActiveIndex(index)}
//               className={`relative flex flex-col items-center justify-center transition-all duration-200 ${
//                 isActive ? '-translate-y-4' : ''
//               }`}
//               style={{ background: 'transparent' }}
//             >
//               {/* Active tab background */}
//               <div
//                 className={`rounded-2xl transition-all duration-200 flex flex-col items-center ${
//                   isActive ? 'shadow-[0_8px_24px_rgba(0,0,0,0.25)]' : ''
//                 }`}
//                 style={{
//                   backgroundColor: isActive ? colors.activeBackground : 'transparent',
//                   padding: isActive ? '14px 16px 10px 16px' : '10px 16px 6px 16px',
//                 }}
//               >
//                 <Icon
//                   className="mb-0.5"
//                   style={{
//                     color: isActive ? colors.activeText : '#ffffff',
//                     width: 24,
//                     height: 24,
//                   }}
//                 />
//                 <span
//                   className="text-xs font-medium whitespace-nowrap"
//                   style={{ color: isActive ? colors.activeText : '#ffffff' }}
//                 >
//                   {item.label}
//                 </span>
//               </div>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default FooterNavLayout4;


// import React, { useState } from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout4Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout4: React.FC<FooterNavLayout4Props> = ({ colors }) => {
//   const items = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home' },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' },
//   ];

//   const [activeIndex, setActiveIndex] = useState<number>(2);

//   return (
//     <div
//       className="rounded-t-2xl shadow-[0_16px_36px_rgba(0,0,0,0.2)] overflow-visible"
//       style={{ backgroundColor: colors.background }}
//     >
//       <div className="grid grid-cols-5 gap-0 items-end">
//         {items.map((item, index) => {
//           const Icon = item.icon;
//           const isActive = index === activeIndex;
//           return (
//             <button
//               key={item.label}
//               type="button"
//               onClick={() => setActiveIndex(index)}
//               className={`relative flex flex-col items-center justify-end transition-all duration-200 border-r last:border-r-0 ${
//                 isActive ? '-translate-y-4' : ''
//               }`}
//               style={{ 
//                 background: 'transparent',
//                 borderColor: 'rgba(255, 255, 255, 0.15)'
//               }}
//             >
//               <div
//                 className={`transition-all duration-200 flex flex-col items-center w-full ${
//                   isActive ? 'shadow-[0_8px_24px_rgba(0,0,0,0.25)] rounded-t-2xl' : ''
//                 }`}
//                 style={{
//                   backgroundColor: isActive ? colors.activeBackground : 'transparent',
//                   paddingTop: isActive ? '14px' : '10px',
//                   paddingLeft: '16px',
//                   paddingRight: '16px',
//                   paddingBottom: '0',
//                 }}
//               >
//                 <Icon
//                   className="mb-1"
//                   style={{
//                     color: isActive ? colors.activeText : '#ffffff',
//                     width: 26,
//                     height: 26,
//                   }}
//                 />
//                 <span
//                   className="text-sm font-medium whitespace-nowrap pb-1"
//                   style={{ color: isActive ? colors.activeText : '#ffffff' }}
//                 >
//                   {item.label}
//                 </span>
//               </div>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default FooterNavLayout4;



import React, { useState } from 'react';
import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout4Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout4: React.FC<FooterNavLayout4Props> = ({ colors }) => {
  const items = [
    { icon: FileText, label: 'History' },
    { icon: CheckSquare, label: 'All Bids' },
    { icon: Home, label: 'Home' },
    { icon: Wallet, label: 'Wallet' },
    { icon: MessageCircle, label: 'Chat' },
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div
      className="rounded-t-xl shadow-[0_16px_36px_rgba(0,0,0,0.2)] overflow-visible"
      style={{ backgroundColor: colors.background }}
    >
      <div className="grid grid-cols-5 gap-0 items-end">
        {items.map((item, index) => {
          const Icon = item.icon;
          const isActive = index === activeIndex;
          return (
            <button
              key={item.label}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={`relative flex flex-col items-center justify-end transition-all duration-200 border-r last:border-r-0 ${
                isActive ? '-translate-y-3.5 -mb-4 rounded-t-lg' : ''
              }`}
              style={{ 
                background: 'transparent',
                borderColor: 'rgba(255, 255, 255, 0.15)'
              }}
            >
              <div
                className={`transition-all duration-200 flex flex-col items-center w-full ${
                  isActive ? 'shadow-[0_8px_24px_rgba(0,0,0,0.25)] rounded-t-2xl' : ''
                }`}
                style={{
                  backgroundColor: isActive ? colors.activeBackground : 'transparent',
                  paddingTop: isActive ? '14px' : '10px',
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  paddingBottom: isActive ? '10px' : '0',
                }}
              >
                <Icon
                  className="mb-1"
                  style={{
                    color: isActive ? colors.activeText : '#ffffff',
                    width: 24,
                    height: 24,
                  }}
                />
                <span
                  className="text-sm font-medium whitespace-nowrap pb-1"
                  style={{ color: isActive ? colors.activeText : '#ffffff' }}
                >
                  {item.label}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNavLayout4;